// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ImportEmployeesRequestModel from '../../model/import-employees-request-model';
import ImportEmployeesRequestDTO from '../dto/import-employees-request-dto';

export default abstract class ImportEmployeesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ImportEmployeesRequestDTO>) {
    super();
    if (data) {
      this.formFile = data.formFile;
    }
  }
  /**
  * @type {binary}
  */
  'formFile'?: File;

  static toModel(dto: DeepPartial<ImportEmployeesRequestDTO>): ImportEmployeesRequestModel;
  static toModel(dto: DeepPartial<ImportEmployeesRequestDTO> | undefined | null): ImportEmployeesRequestModel | undefined;
  static toModel(dto: DeepPartial<ImportEmployeesRequestDTO> | undefined | null): ImportEmployeesRequestModel | undefined {
    return dto ? new ImportEmployeesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ImportEmployeesRequestModel> | ImportEmployeesRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'formFile': unwrapped.formFile,
    } as ImportEmployeesRequestDTO;
  }
}
